var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex align-items-center text-primary cursor-pointer"
        }, [_c('i', {
          staticClass: "fa fa-arrow-left",
          on: {
            "click": function click($event) {
              return _vm.$router.push('/maintenance/main-job-libraries');
            }
          }
        }), _c('h4', {
          staticClass: "card-title text-primary ml-3"
        }, [_c('strong', [_vm._v("Job Library - " + _vm._s(_vm.$route.query.component_name))])])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('JobLibraries')];
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }